import CityPageTemplate from "../city-template/CityPageTemplate";
import { lafayetteCoConfig } from "./data";

export default function LafayetteCoPage() {
  return <CityPageTemplate config={lafayetteCoConfig} />;
}